import React from 'react';
import BottomSheetContainer from "@sharedComponents/Bottomsheet/Bottomsheet";
import {ThemedText, ThemedView} from '@app/theme';
import Button from "@sharedComponents/Button/Button";
import LottieView from "lottie-react-native";

interface SuccessCardProps {
  visible: boolean;
  onClose: () => void;
  lottieSource: any;
  colors: any;
  onContinueClick: () => void;
}

const SuccessCard: React.FC<SuccessCardProps> = ({ visible, onClose, lottieSource, colors, onContinueClick }) => (
  <BottomSheetContainer
    isVisible={visible}
    close={onClose}
    onClose={onClose}
    dragComponent={undefined}
    closeOnBackdropPress={true}
    borderTopRightRadius={10}
    borderTopLeftRadius={10}
    containerStyle={{backgroundColor: '#fefefe'}}
  >
    <ThemedView alignItems={"center"} padding={"lg"}>
      <LottieView source={lottieSource} autoPlay loop style={{ width: 70, height: 70}}/>
      <ThemedText mt={"2xl"} variant={"h5s"} mb={"sm"}>
        KYC done successfully!
      </ThemedText>
      <ThemedText variant={"b3r"} textAlign={"center"} mt={"md"} mb={"2xl"}>
        You will be redirected to next step in few seconds
      </ThemedText>
      <Button
        label="Continue"
        type="OUTLINED"
        size='MD'
        disabled={false}
        handlePress={onContinueClick}
        bg={'bg-action-primary'}
        textColor={colors['text-primary']}
      />
    </ThemedView>
  </BottomSheetContainer>
);

export default SuccessCard; 